import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  html,
  body,
  #__next {
    height: 100%;
  }

  .drop-link, .drop-link * {
    cursor: alias;
  }

  .drop-copy, .drop-copy * {
    cursor: copy;
  }

  .drop-move, .drop-move * {
    cursor: move;
  }

  [data-tippy-root] {
    position: fixed !important;
  }

  .date-range-pickers .react-datepicker-container > div {
    height: 100%;
  }

  @media screen and (max-width: 768px) {
    .date-range-pickers {
      flex-direction: column;
    }
  }

  .react-datepicker {
    font-family: 'Inter', 'Space Grotesk', 'Helvetica', fallback-font, sans-serif;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .react-datepicker-wrapper,
  .react-datepicker__input-container {
    display: block;
  }

  .react-datepicker__input-time-container,
  .react-datepicker__input-time-container
    .react-datepicker-time__input-container
    .react-datepicker-time__input {
    display: none;
    margin-left: 0;
  }

  .react-datepicker__input-time-container
    .react-datepicker-time__input-container
    .react-datepicker-time__input
    input {
    width: unset;
  }

  input, select, textarea {
    font-family: 'Inter', 'Space Grotesk', 'Helvetica', fallback-font, sans-serif;
    outline: none;
  }


  .custom-date-range-picker {
    .react-datepicker {
      border: none;

      .react-datepicker__day--in-range:not(.react-datepicker__day--selected) {
        background-color: #e4e5e9;
        color: black;
      }
    }
  }

  .inactive {
    opacity: 0.5
  }

  .nprogress-busy {
    pointer-events: none;
    cursor: wait;
  }
  #nprogress {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    z-index: 1000;
    left: 0;
    background: rgba(0, 0, 0, 0.4);
  }
  #nprogress .spinner {
    display: block !important;
    position: fixed;
    z-index: 1031;
    top: calc(50% - 50px) !important;
    right: calc(50% - 25px) !important;
  }
  #nprogress .spinner-icon {
    width: 50px !important;
    height: 50px !important;
  }

  .tippy-content div {
    animation: none !important;

    &:before,
    &:after {
      display: none !important;
    }
  }

  .auto-complete-custom-option {
    transition: background 50ms;
  }
  .auto-complete-custom-option:hover {
    transition-delay: 50ms;
    background: #deebff;
  }
  .auto-complete-custom-option.custom-select__option--is-focused {
    background: none;
  }
  .auto-complete-custom-option.custom-select__option--is-selected {
    background: #2684FF;
  }
`;

export default GlobalStyle;
